import { db } from '@/main'
import { doc, updateDoc } from "firebase/firestore";

export default {
  name: 'myaccount',
  components: {},
  props: [],
  data () {
    return {
      view: {
        "loggingOutLoading": false
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    }
  },
  mounted () {

  },
  methods: {
    async logout() {
      console.log('user is logging out')

      this.view.loggingOutLoading = true;

      try {
        
        await this.$store.dispatch('signOut')
  
        this.$router.push('/login')
      } catch (error) {
        this.$toast.error('Error logging out:', error)
      }

    },
    toggleJson () {
      this.user.adminConfig.viewJSON = !this.user.adminConfig.viewJSON
      this.saveAdminConfig()
    },
    async saveAdminConfig () {
      console.log("saving admin config, this.user.id:", this.user.id)

      try {
        await updateDoc(doc(db, "users", this.user.id),{
            'adminConfig': this.user.adminConfig
        })
        console.log("user admin config saved")
        this.$toast.success("Settings Saved")
      } catch (error) {
        console.log("error saving user config:", error)
        this.$toast.error(`Error: ${error}`)
      }
    }
  }
}
